<template>
  <div class="ab_a-title">
    <div class="ab_a-title_result">
      <i
        class="mdi ab_a-title_result_icon"
        :class="correctness_group.icon"
        :style="`color: var(${correctness_group.color})`"
      >
      </i>
    </div>
    <div class="ab_a-title_cards mr-auto">
      <CardRow
        class="ab_a-title_cards_hand"
        size="smaller"
        :cards="hand"
        :hasAnimation="false"
      />
      <PokerBoard
        :hasAnimation="false"
        size="smaller"
        sizeBoards="smallest"
        :board="board"
        :boards="boards"
        style="--height: auto; --boards-direction: row; --boards-gap: 0.5rem"
      />
    </div>
  </div>
</template>

<script>
import PokerBoard from '@/components/PokerTable/PokerBoard'
import CardRow from '@/components/CardRow/CardRow'

export default {
  name: 'HaTitle',
  components: {
    PokerBoard,
    CardRow,
  },
  props: {
    correctness_group: Object,
    hand: String,
    board: String,
    boards: Array,
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_a-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    &_result {
      &_icon {
        font-size: 1.5rem;
      }
    }
    &_cards {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }
}
</style>
